import { saveAs } from 'file-saver'

import { API_ROUTE_ADMIN_INVOICE } from '@/resources/api-routes'
import { getBinary } from '@/util/auth'

export const downloadInvoicePdf = async (id: string): Promise<boolean> => {
  const urlTemplate = API_ROUTE_ADMIN_INVOICE + '/download'
  const response = await getBinary(urlTemplate.replace(':invoiceId', String(id)))

  if (response === undefined) {
    throw Error('could not download invoice file')
  }

  if ([400, 404, 500].includes(response.status)) {
    throw Error('could not download invoice file')
  }

  const filename = response.headers
    ?.get('Content-Disposition')
    ?.split(';')
    ?.find(cp => cp.includes('filename='))
    ?.replace('filename=', '')
    ?.replace(/"/g, '')
    ?.trim()

  if (!filename) {
    throw Error('could not download invoice file')
  }

  saveAs(new Blob([response.buffer]), filename)
  return true
}
